import styled from 'styled-components'

interface IActionTextProps {
  color?: string
}

export const ActionText = styled.span<IActionTextProps>`
  color: ${({ color, theme }) => color || theme.colors.textPill};
  font-size: 12px;
`

export const ActionItemsContainer = styled.div`
  display: flex;
  flex-direction: row;
`

interface IButton {
  $backgroundColor: string
}

export const Button = styled.button<IButton>`
  flex: 1;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border: none;
  cursor: pointer;
`
